export const cacheKeys = {
  getUserIntegrations: 'getUserIntegrations',
};
